import { Mutable } from '@feedyou/utils'
import { NoteStepSchema } from '@feedyou/schema'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type NoteStepReducerState = Mutable<NoteStepSchema>

const slice = createSlice({
  name: 'steps/note',
  initialState: {} as NoteStepReducerState,
  reducers: {
    setText: (step, action: PayloadAction<string>) => {
      step.text = action.payload
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
